import { MatDialog } from "@angular/material/dialog";
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { CdkDetailRowDirective } from "src/app/shared/directive/cdk-detail-row.directive";
import { DialogFieldConfigComponent } from "../dialog-field-config/dialog-field-config.component";
import { FieldConfig } from "src/app/shared/models/field-config.model";
import {
  CdkDragDrop,
  CdkDragStart,
  DragRef,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import { MatTable } from "@angular/material";
import { DialogChangeNameFieldComponent } from "../dialog-difference-process/dialog-change-name-field/dialog-change-name-field.component";
import { DialogGroupNameFieldComponent } from "../dialog-difference-process/dialog-group-name-field/dialog-group-name-field.component";
import { TemplateFieldConfigService } from "src/app/core/services/template-field-config.service";
import { TemplateFieldConfig } from "src/app/shared/models/template-field-config.model";
import { DcFieldConfigService } from "src/app/core/services/dc-field-config.service";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { forkJoin } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { FieldValidation } from "src/app/shared/models/field-validation.model";
import * as lodash from "lodash";
import { ErrorCode } from "src/app/core/constants/error-code";

export interface DataDialog {
  listFields: Array<FieldConfig>;
  listSignatureConfigCustomer: Array<any>;
  fieldConfig: FieldConfig;
  templateId: number;
  orderNoNew: number;
}

@Component({
  selector: "app-field-config",
  templateUrl: "./field-config.component.html",
  styleUrls: ["./field-config.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "void",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("*", style({ height: "*", visibility: "visible" })),
      transition("void <=> *", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class FieldConfigComponent
  extends BaseComponent
  implements OnInit, OnChanges, AfterViewInit {
  @ViewChild("table", { static: true }) table: MatTable<FieldConfig>;
  @ViewChildren("tpl") listTpl: QueryList<MatTable<FieldConfig>>;

  @Input("template_id") templateId: number;
  private mode: "edit" | "create" = "create";

  public templateInformationFormGroup: FormGroup;
  public fileName: string = "abcccacac.docx";

  public dataSource: FieldConfig[] = [];
  public dataCache: FieldConfig[] = [];

  childIsExexpanding: Array<string>;

  public displayedColumns: string[] = [
    "rowIndex",
    "checked",
    "index",
    "name",
    "mergeField",
    "fieldType",
    "required",
    "hide",
    "action",
  ];

  public filter: any = {
    name: "",
    merge_field: "",
  };

  public processClick: boolean = false;
  public dataRowsNeedChange: FieldConfig[] = [];
  public groupNameField: FieldConfig;
  public checkbox = document.getElementsByClassName("check_box");
  public checkBoxList: number[] = [];
  public timeOut: any = null;

  @Input() singleChildRowDetail: boolean;
  @Input() dataRowForMove: FieldConfig;
  @Input() dataRowForGroup: FieldConfig;
  @Input() listSignatureConfigCustomer: any;
  @Output() difference_process: EventEmitter<boolean> = new EventEmitter();
  @Output() dataNameField: EventEmitter<FieldConfig[]> = new EventEmitter();
  @Output() dataGroupField: EventEmitter<FieldConfig[]> = new EventEmitter();
  @Output() groupDisplay: EventEmitter<boolean> = new EventEmitter();
  @Output() moveBtnDisplay: EventEmitter<boolean> = new EventEmitter();
  @Output() clickDialogMergeField: EventEmitter<boolean> = new EventEmitter();
  @Output() displayBtnForm: EventEmitter<boolean> = new EventEmitter(false);
  @Output() isDataForChange: EventEmitter<boolean> = new EventEmitter(false);
  @Input() notPermission: boolean;

  openedRow: CdkDetailRowDirective;

  isExpansionDetailRow = (index, row) => row.hasOwnProperty("detailRow");

  public dragging: DragRef = null;
  public dataDragPreview: FieldConfig[] = [];
  public widthTable: number = null;

  public rowOpened: number[] = [];

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    public templateFieldConfigService: TemplateFieldConfigService,
    public dcFieldConfigService: DcFieldConfigService,
    private toastr: ToastrService
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
    this.initData();
    this.templateInformationFormGroup = new FormGroup({
      nameField: new FormControl(""),
      mergeField: new FormControl(""),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.rowsMove();
    this.rowsGroup();
    if (changes.templateId && changes.templateId.currentValue) {
      this.initData();
    }
    if (changes.notPermission && changes.notPermission.currentValue) {
      this.notPermission = changes.notPermission.currentValue;
    }
  }
  ngAfterViewInit(): void {
    const table = document.getElementById("table-box");
    const boundingClient = table.getBoundingClientRect();
    this.widthTable = boundingClient.width - 20;
  }

  changeOrder(
    currentIndex: number,
    previousIndex: number[],
    listFieldConfig: FieldConfig[]
  ) {
    let dataChange = [];
    const changeMode = currentIndex > previousIndex[0] ? "up" : "down";
    const start = changeMode === "up" ? previousIndex[0] : currentIndex;
    const end =
      changeMode === "up"
        ? currentIndex
        : previousIndex[previousIndex.length - 1];
    if (changeMode === "up") {
      for (const fieldConfig of listFieldConfig) {
        if (fieldConfig.orderNo === start) {
          fieldConfig.orderNo =
            start + end - previousIndex[previousIndex.length - 1];
          dataChange.push(fieldConfig);
          continue;
        }
        if (
          fieldConfig.orderNo > start &&
          fieldConfig.orderNo < start + previousIndex.length
        ) {
          fieldConfig.orderNo =
            fieldConfig.orderNo + end - previousIndex[previousIndex.length - 1];
          dataChange.push(fieldConfig);
          continue;
        }
        if (
          fieldConfig.orderNo > previousIndex[previousIndex.length - 1] &&
          fieldConfig.orderNo < end
        ) {
          fieldConfig.orderNo = fieldConfig.orderNo - previousIndex.length + 1;
          dataChange.push(fieldConfig);
          continue;
        }
        if (fieldConfig.orderNo === end) {
          fieldConfig.orderNo = start;
        }
        dataChange.push(fieldConfig);
      }
    } else {
      for (const fieldConfig of listFieldConfig) {
        if (fieldConfig.orderNo === start) {
          fieldConfig.orderNo = end;
          dataChange.push(fieldConfig);
          continue;
        }
        if (
          fieldConfig.orderNo > start &&
          fieldConfig.orderNo <= end - previousIndex.length
        ) {
          fieldConfig.orderNo = fieldConfig.orderNo + previousIndex.length - 1;
          dataChange.push(fieldConfig);
          continue;
        }
        if (
          fieldConfig.orderNo >= previousIndex[0] &&
          fieldConfig.orderNo <= previousIndex[previousIndex.length - 1]
        ) {
          fieldConfig.orderNo =
            fieldConfig.orderNo - (previousIndex[0] - start);
        }
        dataChange.push(fieldConfig);
      }
    }
    dataChange = dataChange.sort((a, b) => {
      return a.orderNo - b.orderNo;
    });
    return dataChange;
  }

  expandedParent(parentID: string) {
    if (this.childIsExexpanding.includes(parentID)) {
      const index = this.childIsExexpanding.indexOf(parentID, 0);
      if (index > -1) {
        this.childIsExexpanding.splice(index, 1);
      }
      return;
    } else {
      this.childIsExexpanding.push(parentID);
    }
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (
      this.singleChildRowDetail &&
      this.openedRow &&
      this.openedRow.expended
    ) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
      if (!this.rowOpened.includes(row.fieldConfigId)) {
        this.rowOpened.push(row.fieldConfigId);
      }
    } else {
      row.close = false;
      this.rowOpened = this.rowOpened.filter(item => {
        return item !== row.fieldConfigId
      });
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  onOpenDialogFieldConfig(fieldConfig?: any) {
    this.clickDialogMergeField.emit(true);
    let listOrderNo = [];
    if (this.dataCache.length) {
      for (let data of this.dataCache) {
        listOrderNo.push(data.orderNo);
      }
    }
    let maxInNumbers = listOrderNo.length
      ? Math.max.apply(Math, listOrderNo)
      : 0;
    const data: DataDialog = {
      listFields: this.dataCache,
      fieldConfig: fieldConfig,
      templateId: this.templateId,
      orderNoNew: maxInNumbers + 1,
      listSignatureConfigCustomer: this.listSignatureConfigCustomer && this.listSignatureConfigCustomer.length > 0 ? this.listSignatureConfigCustomer : []
    };
    const dialog = this.dialog.open(DialogFieldConfigComponent, {
      width: "80%",
      height: "auto",
      data,
    });
    dialog.afterClosed().subscribe((ref) => {
      this.clickDialogMergeField.emit(false);
      if (ref) {
        this.initData();
        if (fieldConfig) {
          this.toastr.success(
            this.message.getMessage("messages.update_field_config_success")
          );
        } else {
          this.toastr.success(
            this.message.getMessage("messages.add_field_config_success")
          );
        }
      }
    });
  }

  click(event: any) {
    event.stopPropagation();
  }

  initData() {
    if (this.templateId) {
      this.templateFieldConfigService
        .getTemplateFieldConfig(this.templateId)
        .subscribe((response) => {
          if (!response || !response.data) {
            this.dataCache = [];
            this.dataSource = [];
            return;
          }
          let index = 0;
          this.dataCache = response.data.map((item) => {
            item.fieldConfig.templateFieldConfigId = item.templateFieldConfigId;
            item.fieldConfig.rowIndex = index + 1;
            index++;
            if (item.fieldConfig.children) {
              item.fieldConfig.children.forEach((itemChild) => {
                itemChild.rowIndex = index + 1;
                index++;
              });
            }
            return item.fieldConfig;
          });
          console.log('dataCache',this.dataCache,response.data);   
          this.filterData();
          this.checkBoxList = [];
          this.dataRowsNeedChange = [];
          if (this.rowOpened.length) {
            setTimeout(() => {
              this.rowOpened.forEach(item => {
                const index = this.dataSource.findIndex(data => data.fieldConfigId === item);
                if (index !== undefined && index !== -1) {
                  const col = document.getElementById('col-name-' + index);
                  if (col) {
                    col.click();
                  }
                }
              })
            }, 100);
          }
        });
    }
  }

  checkRequiredData(fieldConfig: FieldConfig) {
    const check = fieldConfig.validations.find(
      (validation) => validation.code === "REQUIRED"
    );
    if (check && check.validationValue && JSON.parse(check.validationValue)) {
      return true;
    }
    return false;
  }

  // xu ly drag drop truong
  dropTable(event: CdkDragDrop<FieldConfig[]>) {
    const data = JSON.parse(JSON.stringify(this.dataSource));
    const dragData = event.item.data;
    const arrayIndex =
      event.currentIndex < event.previousIndex
        ? dragData.indices.sort((a, b) => {
          return b - a;
        })
        : dragData.indices.sort((a, b) => {
          return a - b;
        });
    arrayIndex.forEach((element, index) => {
      const indexNew =
        event.currentIndex < event.previousIndex
          ? dragData.value.length - index - 1
          : index;
      const item = dragData.value[indexNew];
      const prevIndex = data.findIndex(
        (d) => d.fieldConfigId === item.fieldConfigId
      );
      moveItemInArray(data, prevIndex, event.currentIndex);
    });
    let childrenAmount = 0;
    const dataChange = data.map((item, index) => {
      item.orderNo = index + 1;
      item.rowIndex = index + childrenAmount + 1;
      if (item.children) {
        item.chilren = item.children.map((child, indexChild) => {
          child.rowIndex = item.rowIndex + indexChild + 1;
          return child;
        });
        childrenAmount += item.children.length;
        item.close = false;
      }
      return item;
    });

    this.dcFieldConfigService
      .saveFieldConfig(dataChange, this.templateId)
      .subscribe((response) => {
        if (!response || !response.data) {
          this.toastr.error(
            this.message.getMessage(
              "messages.change_order_field_config_failed"
            )
          );
          this.initData();
          return;
        }
        this.toastr.success(
          this.message.getMessage(
            "messages.change_order_field_config_success"
          )
        );
        this.dataCache = dataChange;
        this.dataSource = dataChange;
        this.table.renderRows();
      });
  }

  dropTableChild(event: CdkDragDrop<FieldConfig[]>, fieldConfigId: number) {
    const parent: any = this.dataSource.find(
      (item) => item.fieldConfigId === fieldConfigId
    );
    if (parent && parent.children) {
      const data = JSON.parse(JSON.stringify(parent.children));
      const dragData = event.item.data;
      const arrayIndex =
        event.currentIndex < event.previousIndex
          ? dragData.indices.sort((a, b) => {
            return b - a;
          })
          : dragData.indices.sort((a, b) => {
            return a - b;
          });
      arrayIndex.forEach((element, index) => {
        const indexNew =
          event.currentIndex < event.previousIndex
            ? dragData.value.length - index - 1
            : index;
        const item = dragData.value[indexNew];
        const prevIndex = data.findIndex(
          (d) => d.fieldConfigId === item.fieldConfigId
        );
        moveItemInArray(data, prevIndex, event.currentIndex);
      });

      const dataChange = data.map((item, index) => {
        item.orderNo = index + 1;
        item.rowIndex = parent.rowIndex + index + 1;
        return item;
      });

      this.dcFieldConfigService
        .saveFieldConfig(dataChange, this.templateId)
        .subscribe((response) => {
          if (response && response.code === ErrorCode.NotPermissionTemplate) {
            this.toastr.error(this.message.getMessage('messages.check_permission'));
            this.initData();
            return;
          }
          if (!response || !response.data) {
            this.toastr.error(
              this.message.getMessage(
                "messages.change_order_field_config_failed"
              )
            );
            this.initData();
            return;
          }
          this.toastr.success(
            this.message.getMessage(
              "messages.change_order_field_config_success"
            )
          );
          parent.children = dataChange;
          this.dataCache = this.dataSource;
        });
    }
  }

  // mork data
  createFieldConfig(fieldConfigId: number): FieldConfig {
    function makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
    const fieldConfig: FieldConfig = FieldConfig.build();
    fieldConfig.fieldConfigId = fieldConfigId;
    fieldConfig.name = makeid(10);
    fieldConfig.orderNo = fieldConfigId + 1;
    fieldConfig.code = makeid(10).toUpperCase();
    if (fieldConfigId !== 10) {
      fieldConfig.dataType = {
        dataTypeId: 3,
        name: "Nhập",
        code: "input",
      };
      fieldConfig.type = {
        fieldTypeId: 1,
        name: "TextBox",
        code: "textbox",
      };
      fieldConfig.mergeField = "Merge_field_" + fieldConfigId;
      if (Math.round(Math.random()) === 1) {
        fieldConfig.validations = [
          {
            name: "Bắt buôc nhập",
            code: "REQUIRED",
            validationMessage: null,
            validationValue: "true",
            fieldValidationId: 1,
          },
        ];
      } else {
        if (Math.round(Math.random()) === 1) {
          fieldConfig.hide = true;
        }
      }
    }
    return fieldConfig;
  }

  getFieldConfigById(id: number, arrData: any[]) {
    return arrData.find((item) => item.fieldConfigId === id);
  }

  differenceProcessClick() {
    this.dataRowsNeedChange.sort((a, b) => {
      return a.orderNo - b.orderNo;
    });
    if (this.dataRowsNeedChange.length) {
      this.processClick = !this.processClick;
      this.difference_process.emit(this.processClick);

      let dataGroup: FieldConfig[] = [];

      this.dataSource.forEach((data) => {
        if (data.children) {
          dataGroup.push(data);
        }
      });
      if (this.groupNameField) {
        this.groupDisplay.emit(false);
        this.dataNameField.emit(this.groupNameField.children);
      } else {
        this.groupDisplay.emit(true);
        this.dataNameField.emit(this.dataSource);
      }
      this.dataGroupField.emit(dataGroup);

      for (let i = 1; i < this.dataRowsNeedChange.length; i++) {
        if (
          this.dataRowsNeedChange[i].orderNo -
          this.dataRowsNeedChange[i - 1].orderNo >
          1
        ) {
          this.moveBtnDisplay.emit(false);
          break;
        }
      }
    }
  }

  toggle(event: any, data: FieldConfig, datachild?: FieldConfig) {
    if (datachild) {
      if (event.checked == true) {
        this.checkBoxList.push(datachild.fieldConfigId);
        this.dataRowsNeedChange.push(datachild);
      } else {
        this.checkBoxList = this.checkBoxList.filter((id) => {
          return id !== datachild.fieldConfigId;
        });
        this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
          return item.fieldConfigId !== datachild.fieldConfigId;
        });
        if (this.checkBoxList.includes(data.fieldConfigId)) {
          this.checkBoxList = this.checkBoxList.filter((id) => {
            return id !== data.fieldConfigId;
          });
          this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
            return item.fieldConfigId !== data.fieldConfigId;
          });
        }
      }
    } else {
      if (event.checked == true) {
        this.checkBoxList.push(data.fieldConfigId);
        this.dataRowsNeedChange.push(data);
        if (data.children) {
          data.children.forEach((child) => {
            if (!this.checkBoxList.includes(child.fieldConfigId)) {
              this.checkBoxList.push(child.fieldConfigId);
              this.dataRowsNeedChange.push(child);
            }
          });
        }
      } else {
        this.checkBoxList = this.checkBoxList.filter((id) => {
          return id !== data.fieldConfigId;
        });
        this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
          return item.fieldConfigId !== data.fieldConfigId;
        });
        if (data.children) {
          const childIds = data.children.map((child) => {
            return child.fieldConfigId;
          });
          this.checkBoxList = this.checkBoxList.filter((id) => {
            return !childIds.includes(id);
          });
          this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
            return !childIds.includes(item.fieldConfigId);
          });
        }
      }
    }
  }

  clickAll(event: any) {
    if (event.checked == true) {
      this.checkBoxList = [];
      const dataChange = [];
      this.dataSource.forEach((field) => {
        this.checkBoxList.push(field.fieldConfigId);
        dataChange.push(field);
        if (field.children) {
          field.children.forEach((child) => {
            this.checkBoxList.push(child.fieldConfigId);
            dataChange.push(child);
          });
        }
      });
      this.dataRowsNeedChange = JSON.parse(JSON.stringify(dataChange));
    } else {
      this.checkBoxList = [];
      this.dataRowsNeedChange = [];
    }
  }

  rowsMove() {
    if (this.dataRowForMove && this.dataRowsNeedChange) {
      let previousIndexs: number[] = [];
      this.dataRowsNeedChange.forEach((data) => {
        previousIndexs.push(data.orderNo);
      });
      if (this.groupNameField) {
        this.groupNameField.children = this.changeOrder(
          this.dataRowForMove.orderNo,
          previousIndexs,
          this.groupNameField.children
        );
      } else {
        this.dataSource = this.changeOrder(
          this.dataRowForMove.orderNo,
          previousIndexs,
          this.dataSource
        );
      }
      this.dataRowsNeedChange = [];
      this.processClick = !this.processClick;
      this.difference_process.emit(this.processClick);
      let elms = document.getElementsByClassName("check_box");
      for (let i = 0; i < elms.length; i++) {
        if (elms.item(i).classList.contains("mat-checkbox-checked")) {
          elms.item(i).classList.remove("mat-checkbox-checked");
        }
      }
      this.table.renderRows();
    }
  }

  rowsGroup() {
    if (this.dataRowForGroup && this.dataRowsNeedChange) {
      const startChangeIndex = this.dataRowsNeedChange[0].orderNo - 1;
      this.dataRowsNeedChange.forEach((data) => {
        data.fieldConfigId = this.dataRowForGroup.children.length;
        data.orderNo = this.dataRowForGroup.children.length + 1;
        this.dataRowForGroup.children.push(data);
      });
      this.dataSource.splice(startChangeIndex, this.dataRowsNeedChange.length);
      for (const fieldConfig of this.dataSource) {
        if (
          fieldConfig.orderNo >=
          startChangeIndex + this.dataRowsNeedChange.length
        ) {
          fieldConfig.orderNo -= this.dataRowsNeedChange.length;
        }
      }
      this.dataRowsNeedChange = [];
      this.processClick = !this.processClick;
      this.difference_process.emit(this.processClick);
      let elms = document.getElementsByClassName("check_box");
      for (let i = 0; i < elms.length; i++) {
        if (elms.item(i).classList.contains("mat-checkbox-checked")) {
          elms.item(i).classList.remove("mat-checkbox-checked");
        }
      }
      this.table.renderRows();
    }
  }

  checkOrder(data: FieldConfig, nameClass: string) {
    if (this.dataRowsNeedChange.length) {
      if (
        data.orderNo >
        this.dataRowsNeedChange[this.dataRowsNeedChange.length - 1].orderNo +
        1 ||
        data.orderNo < this.dataRowsNeedChange[0].orderNo - 1
      ) {
        setTimeout(() => {
          let elms = document.getElementsByClassName(nameClass);
          elms.item(data.orderNo - 1).classList.remove("mat-checkbox-checked");
        }, 0);
      } else {
        this.dataRowsNeedChange.push(data);
        this.dataRowsNeedChange.sort((a, b) => {
          return a.orderNo - b.orderNo;
        });
        this.dataNameField.emit(this.dataSource);
      }
    } else {
      this.dataRowsNeedChange.push(data);
      this.dataRowsNeedChange.sort((a, b) => {
        return a.orderNo - b.orderNo;
      });
      this.dataNameField.emit(this.dataSource);
    }
    this.table.renderRows();
  }

  deleteTemplateFieldConfig(fieldConfig: FieldConfig) {
    this.displayBtnForm.emit(true);
    const dataDialog = fieldConfig.group
      ? this.commonService.format(
        this.message.getMessage("messages.delete_group_confirm"),
        fieldConfig.name
      )
      : this.commonService.format(
        this.message.getMessage("messages.confirm_delete_field_config"),
        fieldConfig.name
      );
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: dataDialog,
    });
    warnDialog.afterClosed().subscribe((ref) => {
      this.displayBtnForm.emit(false);
      if (ref) {
        this.dcFieldConfigService
          .deleteFieldConfig([fieldConfig.fieldConfigId], this.templateId)
          .subscribe((response) => {
            if (response && response.code === ErrorCode.NotPermissionTemplate) {
              this.toastr.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (!response || !response.data) {
              return;
            }
            const temp = this.dataCache.filter(
              (item) => item.fieldConfigId != fieldConfig.fieldConfigId
            );
            this.checkBoxList = this.checkBoxList.filter((item) => {
              return item !== fieldConfig.fieldConfigId;
            });
            this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
              return item.fieldConfigId !== fieldConfig.fieldConfigId;
            });
            const dataChange = temp.map((item, index) => {
              item.orderNo = index + 1;
              return item;
            });
            this.dcFieldConfigService
              .saveFieldConfig(dataChange, this.templateId)
              .subscribe((res) => {
                if (response && response.code === ErrorCode.NotPermissionTemplate) {
                  this.toastr.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                this.initData();
              });
            this.toastr.success(
              this.message.getMessage("messages.delete_field_config_success")
            );
          });
      }
    });
  }

  deleteFieldConfid(fieldConfig: FieldConfig, parent: FieldConfig) {
    this.displayBtnForm.emit(true);
    const dataDialog = this.commonService.format(
      this.message.getMessage("messages.confirm_delete_field_config"),
      fieldConfig.name
    );
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: dataDialog,
    });
    warnDialog.afterClosed().subscribe((ref) => {
      this.displayBtnForm.emit(false);
      if (ref) {
        this.dcFieldConfigService
          .deleteFieldConfig([fieldConfig.fieldConfigId], this.templateId)
          .subscribe((response) => {
            if (response && response.code === ErrorCode.NotPermissionTemplate) {
              this.toastr.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (!response || !response.data) {
              return;
            }
            const temp = parent.children.filter((item) => item != fieldConfig);
            if (!temp.length) {
              this.initData();
              this.toastr.success(
                this.message.getMessage("messages.delete_field_config_success")
              );
              return;
            }
            const dataNew = temp.map((item, index) => {
              item.orderNo = index + 1;
              return item;
            });
            this.checkBoxList = this.checkBoxList.filter((item) => {
              return item !== fieldConfig.fieldConfigId;
            });
            this.dataRowsNeedChange = this.dataRowsNeedChange.filter((item) => {
              return item.fieldConfigId !== fieldConfig.fieldConfigId;
            });
            this.dcFieldConfigService
              .saveFieldConfig(dataNew, this.templateId)
              .subscribe((response) => {
                if (response && response.code === ErrorCode.NotPermissionTemplate) {
                  this.toastr.error(this.message.getMessage('messages.check_permission'));
                  return;
                }
                if (!response || !response.data) {
                  return;
                }
                this.initData();
                this.toastr.success(
                  this.message.getMessage(
                    "messages.delete_field_config_success"
                  )
                );
              });
          });
      }
    });
  }

  removeVietnameseTones(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    // str = str.replace(/ + /g, " ");
    str = str.trim();
    return str;
  }

  // loc du lieu theo ten hoac merge field
  filterData() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    if (!this.filter.name && !this.filter.merge_field) {
      this.dataSource = this.dataCache;
      return;
    }
    this.timeOut = setTimeout(() => {
      const nameFind = this.filter.name
        ? this.removeVietnameseTones(this.filter.name.trim()).toLowerCase()
        : null;
      const mergeFieldFind = this.filter.merge_field
        ? this.removeVietnameseTones(
          this.filter.merge_field.trim()
        ).toLowerCase()
        : null;

      this.dataSource = [];
      this.dataCache.forEach((item) => {
        const config = JSON.parse(JSON.stringify(item));
        const mergeField = config.mergeField
          ? this.removeVietnameseTones(config.mergeField.trim()).toLowerCase()
          : null;
        const name = config.name
          ? this.removeVietnameseTones(config.name.trim()).toLowerCase()
          : null;

        if (!nameFind && mergeField && mergeField.includes(mergeFieldFind)) {
          this.dataSource.push(config);
        } else if (!mergeFieldFind && name && name.includes(nameFind)) {
          this.dataSource.push(config);
        } else if (
          mergeField && name &&
          name.includes(nameFind) &&
          mergeField.includes(mergeFieldFind)
        ) {
          this.dataSource.push(config);
        } else if (config.group) {
          config.close = false;
          config.children = config.children.filter((child) => {
            const mergeFieldChild = child.mergeField
              ? this.removeVietnameseTones(child.mergeField).toLowerCase()
              : null;
            const nameChild = child.name
              ? this.removeVietnameseTones(child.name).toLowerCase()
              : null;

            if (!nameFind && mergeFieldChild) {
              return mergeFieldChild.includes(mergeFieldFind);
            } else if (!mergeFieldFind && nameChild) {
              return nameChild.includes(nameFind);
            } else {
              return (mergeFieldChild && nameChild &&
                mergeFieldChild.includes(mergeFieldFind) &&
                nameChild.includes(nameFind)
              );
            }
          });
          if (config.children.length) {
            this.dataSource.push(config);
          }
        }
      });
    });
  }

  // xoa nhieu truong config
  deleteFieldConfigs() {
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: this.message.getMessage("messages.confirm_delete_field_configs"),
    });
    warnDialog.afterClosed().subscribe((ref) => {
      if (ref) {
        const data = this.dataCache.filter((item) => {
          return !this.checkBoxList.includes(item.fieldConfigId);
        });
        const templateDelete = this.dataRowsNeedChange.filter((item) => {
          return item.templateFieldConfigId;
        });
        const templateFieldConfigDelete = templateDelete.map((item) => {
          return item.fieldConfigId;
        });
        const fieldConfigDelete = this.dataRowsNeedChange.filter((item) => {
          return item.parentId && !this.checkBoxList.includes(item.parentId);
        });
        const fieldConfigIdsDelete = fieldConfigDelete.map((item) => {
          return item.fieldConfigId;
        });
        const fieldConfigChange = data.map((item, index) => {
          item.orderNo = index + 1;
          if (item.children) {
            item.children = item.children.filter((child) => {
              return !this.checkBoxList.includes(child.fieldConfigId);
            });
            item.children = item.children.map((child, indexChild) => {
              child.orderNo = indexChild + 1;
              return child;
            });
          }
          return item;
        });
        let listIds = [];
        if (fieldConfigIdsDelete.length) {
          listIds = listIds.concat(fieldConfigIdsDelete);
        }
        if (templateFieldConfigDelete.length) {
          listIds = listIds.concat(templateFieldConfigDelete);
        }
        this.dcFieldConfigService
          .deleteFieldConfig(listIds, this.templateId)
          .subscribe((response: any) => {
            if (response && response.code === ErrorCode.NotPermissionTemplate) {
              this.toastr.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            if (response && !response.data) {
              this.toastr.error(
                this.message.getMessage("messages.delete_field_config_error")
              );
              this.initData();
              return;
            }
            this.dataRowsNeedChange = [];
            this.checkBoxList = [];
            if (fieldConfigChange.length) {
              this.dcFieldConfigService
                .saveFieldConfig(fieldConfigChange, this.templateId)
                .subscribe((resSave) => {
                  if (resSave && resSave.data) {
                    this.toastr.success(
                      this.message.getMessage(
                        "messages.delete_field_config_success"
                      )
                    );
                  }
                  this.processClick = !this.processClick;
                  this.difference_process.emit(this.processClick);
                  this.initData();
                });
              return;
            }
            this.processClick = !this.processClick;
            this.difference_process.emit(this.processClick);
            this.toastr.success(
              this.message.getMessage("messages.delete_field_config_success")
            );
            this.initData();
          });
      }
    });
  }

  clearData(data: string) {
    if (data == this.filter.name) {
      this.filter.name = null;
    } else this.filter.merge_field = null;
    this.filterData();
  }

  copyFieldConfig(event, fieldConfig: FieldConfig) {
    event.preventDefault();
    const fieldConfigSames = this.dataCache.filter((item) => {
      const regex = new RegExp(`^${fieldConfig.name}_COPY_([0-9]{1,})$`);
      const mergeRegex = new RegExp(
        `^${fieldConfig.mergeField}_COPY_([0-9]{1,})$`
      );
      return (
        mergeRegex.test(item.mergeField) ||
        (!fieldConfig.mergeField && regex.test(item.name))
      );
    });

    const dataNew: FieldConfig = Object.assign({}, fieldConfig);
    dataNew.fieldConfigId = null;
    dataNew.code = null;
    const name = fieldConfig.name + "_COPY_" + (fieldConfigSames.length + 1);
    if (fieldConfig.mergeField) {
      if (fieldConfig.mergeField.length >= 200) {
        this.toastr.error(
          this.message.getMessage("messages.merge_field_copy_error")
        );
        return;
      }
      const mergeField =
        fieldConfig.mergeField + "_COPY_" + (fieldConfigSames.length + 1);

      if (mergeField.length > 200) {
        this.toastr.error(
          this.message.getMessage("messages.merge_field_copy_error")
        );
        return;
      }
      dataNew.mergeField = mergeField;
    } else dataNew.mergeField = null;
    if (fieldConfig.startGroup) {
      if (fieldConfig.startGroup.replace("START_", "").length >= 200) {
        this.toastr.error(
          this.message.getMessage("messages.name_group_copy_error")
        );
        return;
      }
      const nameGroup =
        fieldConfig.startGroup.replace("START_", "") +
        "_COPY_" +
        (fieldConfigSames.length + 1);
      if (nameGroup.length > 200) {
        this.toastr.error(
          this.message.getMessage("messages.name_group_copy_error")
        );
        return;
      }
      dataNew.startGroup =
        fieldConfig.startGroup + "_COPY_" + (fieldConfigSames.length + 1);
      dataNew.endGroup =
        fieldConfig.endGroup + "_COPY_" + (fieldConfigSames.length + 1);
    }
    if (fieldConfig.name.length >= 200) {
      dataNew.name = fieldConfig.name;
    } else {
      dataNew.name = name.length > 200 ? name.slice(0, 200) : name;
    }

    dataNew.orderNo = this.dataCache.length + 1;
    dataNew.validations = [];
    if (fieldConfig.validations.length) {
      fieldConfig.validations.forEach((item) => {
        if (item.code === "MINLENGTH") {
          let validation = FieldValidation.build();
          validation.code = "MINLENGTH";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
        }
        if (item.code === "MAXLENGTH") {
          let validation = FieldValidation.build();
          validation.code = "MAXLENGTH";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
        }
        if (item.code === "REQUIRED") {
          let validation = FieldValidation.build();
          validation.code = "REQUIRED";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
        }
      });
    }

    if (fieldConfig.children) {
      dataNew.children = fieldConfig.children.map((child) => {
        child.fieldConfigId = null;
        child.validations.forEach((childVal) => {
          if (childVal.code === "MINLENGTH") {
            let validation = FieldValidation.build();
            validation.code = "MINLENGTH";
            validation.name = childVal.name;
            validation.validationValue = childVal.validationValue;
            dataNew.validations.push(validation);
          }
          if (childVal.code === "MAXLENGTH") {
            let validation = FieldValidation.build();
            validation.code = "MAXLENGTH";
            validation.name = childVal.name;
            validation.validationValue = childVal.validationValue;
            dataNew.validations.push(validation);
          }
          if (childVal.code === "REQUIRED") {
            let validation = FieldValidation.build();
            validation.code = "REQUIRED";
            validation.name = childVal.name;
            validation.validationValue = childVal.validationValue;
            dataNew.validations.push(validation);
          }
        });
        child.code = null;
        child.name = child.name + "_COPY_" + (fieldConfigSames.length + 1);
        if (child.name.length > 200) {
          child.name = child.name.slice(0, 200);
        }
        if (child.mergeField) {
          child.mergeField =
            child.mergeField + "_COPY_" + (fieldConfigSames.length + 1);
        }
        return child;
      });
      const fieldError = dataNew.children.filter((item) => {
        return item.mergeField && item.mergeField.length > 200;
      });
      if (fieldError.length) {
        this.toastr.error(
          this.message.getMessage("messages.merge_field_copy_error")
        );
        return;
      }
    }

    const templateFieldConfig: TemplateFieldConfig =
      TemplateFieldConfig.build();
    templateFieldConfig.fieldConfig = dataNew;
    templateFieldConfig.templateId = this.templateId;
    this.templateFieldConfigService
      .saveAllTemplateFieldConfig([templateFieldConfig], this.templateId)
      .subscribe((resposne) => {
        if (!resposne || !resposne.data || !resposne.data.length) {
          this.toastr.error(
            this.commonService.format(
              this.message.getMessage("messages.copy_field_error"),
              fieldConfig.name
            )
          );
          return;
        }
        this.toastr.success(
          this.commonService.format(
            this.message.getMessage("messages.copy_field_success"),
            fieldConfig.name
          )
        );
        this.initData();
      });
  }

  isChecked(id: number): boolean {
    return this.checkBoxList.includes(id);
  }

  displayTooltip(data: FieldConfig, index, class_name) {
    let elms_span = document.getElementsByClassName(class_name);
    let elms_cell = document.getElementsByClassName("cell");
    if (index && elms_span.item(index) && elms_cell.item(index)) {
      if (
        (class_name === "nameField" &&
          elms_span.item(index).scrollWidth + 30 >
          elms_cell.item(index).scrollWidth) ||
        (class_name === "mergeField" &&
          elms_span.item(index).scrollWidth > elms_cell.item(index).scrollWidth)
      ) {
        return data;
      } else return null;
    } else return null;
  }

  dragStarted(ev: CdkDragStart, index: number) {
    this.dragging = ev.source._dragRef;
    let indices: number[] = [];
    if (!this.checkBoxList.length) {
      indices = [index];
    } else {
      this.dataSource.forEach((item, index) => {
        if (this.checkBoxList.includes(item.fieldConfigId)) {
          indices.push(index);
        }
      });
      if (!indices.includes(index)) {
        indices = [index];
      }
    }
    this.dataDragPreview = indices.map((i) => this.dataSource[i]);
    ev.source.data = {
      indices,
      value: indices.map((i) => this.dataSource[i]),
      source: this,
    };
    this.cdr.detectChanges();
  }

  dragEnded() {
    this.dragging = null;
    this.dataDragPreview = [];
    this.cdr.detectChanges();
  }

  dragStartedChild(ev: CdkDragStart, index: number, parentId: number) {
    this.dragging = ev.source._dragRef;
    let indices: number[] = [];
    const parent = this.dataSource.find(
      (item) => item.fieldConfigId === parentId
    );
    if (parent && parent.children) {
      if (!this.checkBoxList.length) {
        indices = [index];
      } else {
        parent.children.forEach((item, index) => {
          if (this.checkBoxList.includes(item.fieldConfigId)) {
            indices.push(index);
          }
        });
        if (!indices.includes(index)) {
          indices = [index];
        }
      }
      this.dataDragPreview = indices.map((i) => parent.children[i]);

      ev.source.data = {
        indices,
        value: indices.map((i) => parent.children[i]),
        source: this,
      };
      this.cdr.detectChanges();
    }
  }

  isHidden(element: FieldConfig) {
    const index = this.dataDragPreview.findIndex(
      (item) => item.fieldConfigId === element.fieldConfigId
    );
    return index > 0 ? true : false;
  }

  isAllowDragDrop() {
    let isNotAllow = false;
    for (const fieldConfig of this.dataSource) {
      if (
        !this.checkBoxList.includes(fieldConfig.fieldConfigId) &&
        fieldConfig.children
      ) {
        const childrenChecked = fieldConfig.children.filter((child) => {
          return this.checkBoxList.includes(child.fieldConfigId);
        });
        if (childrenChecked.length) {
          isNotAllow = true;
          break;
        }
      }
    }
    return isNotAllow;
  }

  isAllowDragDropChild() {
    let isNotAllow = false;
    let groupIsChildChecked: number = null;
    let level = null;
    for (const fieldConfig of this.dataSource) {
      if (this.checkBoxList.includes(fieldConfig.fieldConfigId)) {
        if (level === "child") {
          isNotAllow = true;
          break;
        }
        level = "parent";
      }
      if (fieldConfig.children) {
        const childrenChecked = fieldConfig.children.filter((child) => {
          return this.checkBoxList.includes(child.fieldConfigId);
        });
        if (childrenChecked.length) {
          if (
            childrenChecked.length === fieldConfig.children.length ||
            level ||
            groupIsChildChecked
          ) {
            isNotAllow = true;
            break;
          } else {
            groupIsChildChecked = fieldConfig.fieldConfigId;
            level = "child";
          }
        }
      }
    }
    return isNotAllow;
  }

  copyFieldConfigChild(
    event,
    fieldConfig: FieldConfig,
    fieldChild: FieldConfig
  ) {
    event.preventDefault();
    const fieldConfigSames = fieldConfig.children.filter((item) => {
      const regex = new RegExp(`^${fieldChild.name}_COPY_([0-9]{1,})$`);
      const mergeRegex = new RegExp(
        `^${fieldChild.mergeField}_COPY_([0-9]{1,})$`
      );
      return (
        mergeRegex.test(item.mergeField) ||
        (!fieldChild.mergeField && regex.test(item.name))
      );
    });

    const dataNew: FieldConfig = Object.assign({}, fieldChild);
    dataNew.fieldConfigId = null;
    dataNew.code = null;
    const name = fieldChild.name + "_COPY_" + (fieldConfigSames.length + 1);
    if (fieldChild.mergeField) {
      if (fieldChild.mergeField.length >= 200) {
        this.toastr.error(
          this.message.getMessage("messages.merge_field_copy_error")
        );
        return;
      }
      const mergeField =
        fieldChild.mergeField + "_COPY_" + (fieldConfigSames.length + 1);

      if (mergeField.length > 200) {
        this.toastr.error(
          this.message.getMessage("messages.merge_field_copy_error")
        );
        return;
      }
      dataNew.mergeField = mergeField;
    } else dataNew.mergeField = null;
    if (fieldConfig.name.length >= 200) {
      dataNew.name = fieldConfig.name;
    } else {
      dataNew.name = name.length > 200 ? name.slice(0, 200) : name;
    }

    dataNew.orderNo = fieldConfig.children.length + 1;
    dataNew.validations = [];
    if (fieldConfig.validations.length) {
      fieldConfig.validations.forEach((item) => {
        if (item.code === "MINLENGTH") {
          let validation = FieldValidation.build();
          validation.code = "MINLENGTH";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
          return;
        }
        if (item.code === "MAXLENGTH") {
          let validation = FieldValidation.build();
          validation.code = "MAXLENGTH";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
          return;
        }
        if (item.code === "REQUIRED") {
          let validation = FieldValidation.build();
          validation.code = "REQUIRED";
          validation.name = item.name;
          validation.validationValue = item.validationValue;
          dataNew.validations.push(validation);
          return;
        }
      });
    }

    this.dcFieldConfigService
      .saveFieldConfig([dataNew], this.templateId)
      .subscribe((resposne) => {
        if (resposne && resposne.code === ErrorCode.NotPermissionTemplate) {
          this.toastr.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (!resposne || !resposne.data || !resposne.data.length) {
          this.toastr.error(
            this.commonService.format(
              this.message.getMessage("messages.copy_field_error"),
              fieldChild.name
            )
          );
          return;
        }
        this.toastr.success(
          this.commonService.format(
            this.message.getMessage("messages.copy_field_success"),
            fieldChild.name
          )
        );
        this.initData();
      });
  }

  openGroupDialog() {
    const dialogRef = this.dialog.open(DialogGroupNameFieldComponent, {
      width: "40%",
      data: this.dataCache.filter((item) => {
        return item.group;
      }),
    });

    dialogRef.afterClosed().subscribe((rs) => {
      if (!rs) {
        dialogRef.close();
        return;
      }

      if (!this.checkIsAllowGrouping()) {
        this.toastr.warning(
          this.message.getMessage("messages.warning_grouping")
        );
        dialogRef.close();
        return;
      }
      this.groupingData(rs);
    });
  }

  checkIsAllowGrouping() {
    const fieldIsInvalid = this.dataRowsNeedChange.filter((item) => {
      return item.group || item.parentId;
    });
    return !fieldIsInvalid.length ? true : false;
  }

  groupingData(parent: FieldConfig) {
    let indexChild = parent.children.length;
    const idTemplateConfig = this.dataRowsNeedChange.map((item) => {
      return item.templateFieldConfigId;
    });
    let dataTableNew = this.dataCache.filter((field) => {
      return !this.checkBoxList.includes(field.fieldConfigId);
    });
    let dataNew = this.dataRowsNeedChange.map((item) => {
      item.templateFieldConfigId = null;
      item.orderNo = indexChild + 1;
      indexChild++;
      item.parentId = parent.fieldConfigId;
      return item;
    });

    dataTableNew = dataTableNew.map((item, index) => {
      item.orderNo = index + 1;
      if (item.fieldConfigId === parent.fieldConfigId) {
        parent.children = parent.children.concat(dataNew);
      }
      return item;
    });

    forkJoin([
      this.templateFieldConfigService.deleteTemplateFieldConfig(
        idTemplateConfig
      ),
      this.dcFieldConfigService.saveFieldConfig(dataTableNew, this.templateId),
    ]).subscribe((response) => {
      if (!response || !response.length) {
        return;
      }
      this.toastr.success(this.message.getMessage("messages.grouping_success"));
      this.checkBoxList = [];
      this.dataRowsNeedChange = [];
      this.initData();
    });
  }
}
